import {
  createCoaching,
  getCoachingVertragRef,
  getCoachingVoucherRef,
  getGueltigkeit,
  patchCoaching,
} from './coaching'
import { getMassnahmeTbFields, getMassnahmeUeBudget, listMassnahmen } from './massnahmen'
import { getPersonRecords } from './person'
import { createDokument, patchDokument } from './dokumente'

export const AZAV_SUBTYPE = {
  getPersonRecords,
  getGueltigkeit,
  createCoaching,
  patchCoaching,
  getCoachingVertragRef,
  getCoachingVoucherRef,
  getMassnahmeUeBudget,
  listMassnahmen,
  getMassnahmeTbFields,
  createDokument,
  patchDokument,
}
